<template>
  <div class="charge-detail">
    <div class="main">
      <div class="list">
        <div class="name-label">{{ $t('lang.Device ID') }}：</div>
        <div class="value-label">{{ data.deviceNo }}</div>
        <!-- <div class="name-label">壳体编号：</div>
        <div class="value-label">{{ data.shellNo }}</div> -->
        <div class="name-label">{{ $t('lang.Communication board number') }}：</div>
        <div class="value-label">{{ data.communicationBoardNo }}</div>
        <!-- <div class="name-label">电池二维码：</div>
        <div class="value-label">{{ data.linkNo }}</div> -->
        <div class="name-label">{{ $t('lang.Equipment type') }}：</div>
        <div class="value-label">{{ $t('lang.Battery') }}</div>
      </div>
      <div class="list">
        <!-- <div class="name-label">{{ $t('lang.Device address') }}：</div> -->
        <!-- <div class="value-label">{{ data.location }}</div> -->
        <div class="name-label">{{ $t('lang.Attribution Object Type') }}：</div>
        <div class="value-label" style="width: 207px" v-html="belongTargetInfo"></div>
        <div class="name-label">{{ $t('lang.Lock Cause') }}：</div>
        <div class="value-label">{{ data.lockReason }}</div>
      </div>
      <div class="list"></div>
     
      <el-table :data="[data]" style="width: 100%;margin-bottom: 20px;" class="table-custom">
        <el-table-column prop="version" :label="$t('lang.Battery version')" width="150px">
          <template slot-scope="{row}">
            {{ versionMap[row.version] }}
          </template>
        </el-table-column>
        <el-table-column prop="Vehicle Spec" :label="$t('lang.Battery specification')" width="180px" >
          <template slot-scope="{row}">
            {{ row.ratedVoltageStandard}}
          </template>
        </el-table-column>
        <el-table-column prop="out of power" :label="$t('Health level')" width="150px">
          <template slot-scope="{row}">
            {{ row.soc }}
          </template>
        </el-table-column>
        <el-table-column prop="health" :label="$t('lang.health')  + ' ' + $t('lang.State') " width="150px" >
          <template slot-scope="{row}">
            {{ row.soh }}
          </template>
        </el-table-column>
        <el-table-column prop="voltage" :label="$t('lang.Battery')  + ' ' + $t('lang.voltage') " width="150px">
          <template slot-scope="{row}">
            {{ row.electricVoltage }}
          </template>
        </el-table-column>
        <el-table-column prop="current" :label="$t('lang.Battery')  + ' ' + $t('lang.current') " width="150px">
          <template slot-scope="{row}">
            {{ row.electricCurrent }}
          </template>
        </el-table-column>
        <el-table-column prop="voltage difference" :label="$t('lang.Battery')  + ' ' + $t('lang.voltage difference') " width="250px">
          <template slot-scope="{row}">
            {{ row.voltageDifference }}
          </template>
        </el-table-column>

        <el-table-column prop="Max" :label="$t('lang.Max battery temperature')" width="240px">
          <template slot-scope="{row}">
            {{ row.maxTemperature  }}
          </template>
        </el-table-column>
        <el-table-column prop="Min" :label="$t('lang.Min battery temperature')" width="240px">
          <template slot-scope="{row}">
            {{ row.minTemperature  }}
          </template>
        </el-table-column>
        <el-table-column prop="Discharge" :label="$t('lang.Discharge MOS temperature')" width="240px">
          <template slot-scope="{row}">
            {{ row.dischargeMosTemperature  }}
          </template>
        </el-table-column>
        <el-table-column prop="Charge" :label="$t('lang.Charge MOS temperature')" width="240px">
          <template slot-scope="{row}">
            {{ row.chargingMosTemperature  }}
          </template>
        </el-table-column>

        <el-table-column prop="status" :label="$t('lang.Battery status')" width="150px">
          <template slot-scope="{row}">
            {{ row.useStatusStr  }}
          </template>
        </el-table-column>
        <el-table-column prop="Version" :label="$t('lang.Software Version')" width="180px">
          <template slot-scope="{row}">
            {{ row.softwareVersion  }}
          </template>
        </el-table-column>
        <el-table-column prop="Hardware" :label="$t('lang.Hardware Version')" width="180px">
          <template slot-scope="{row}">
            {{ row.hardwareVersion  }}
          </template>
        </el-table-column>
        <el-table-column prop="type" :label="$t('lang.Hardware type')" width="150px">
          <template slot-scope="{row}">
            {{ row.hardwareType  }}
          </template>
        </el-table-column>

      </el-table>
    </div>
    <el-dialog :title="$t('lang.Battery Status')" width="30%" :visible.sync="dialogVisible">
      <span>{{$t('lang.Please select battery status')}}</span>
      <el-select class="fixed-width-100" size="mini" v-model="editStatus">
        <el-option v-for="(item, key) in statusList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="cancel">{{ $t('lang.Cancel') }}</el-button>
        <el-button type="primary" @click="confirm">{{ $t('lang.Confirm') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="$t('lang.View cell voltage')" width="610px" :visible.sync="cellVoltageDialogVisible" center>
      <div class="list">
        <span>{{ $t('lang.time') }}</span>
        <el-date-picker v-model="cellVoltageStartTime" type="datetime" format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm" :placeholder="$t('lang.start time')"  size="mini" class="ml-10"
          @change="onCellVoltageQueryClick"></el-date-picker>
        <el-date-picker v-model="cellVoltageEndTime" type="datetime" format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm" :placeholder="$t('lang.end time')"  size="mini" class="ml-10"
          @change="onCellVoltageQueryClick"></el-date-picker>
      </div>
      <div class="list mt-10">
        <span>{{ $t('lang.Cell voltage number') }}</span>
        <el-select class="fixed-width-100 ml-10" size="mini" v-model="cellSeqNo" @change="onCellVoltageQueryClick">
          <el-option v-for="(item) in cellSeqNoList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-button type="primary ml-10 w-100" size="mini" @click="onCellVoltageQueryClick">{{ $t('lang.Inquire') }}</el-button>
      </div>
      <el-table v-loading="loading" :data="tableData" style="width: 100%" class="mt-10">
        <el-table-column prop="createTime" :label="$t('lang.Receiving time')" width="230"></el-table-column>
        <el-table-column prop="cellSeqNo" :label="$t('lang.Cell voltage number')"></el-table-column>
        <el-table-column prop="electricVoltage" :label="$t('lang.voltage')"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary w-100" @click="onCellVoltagePrePageClick"
          :disabled="cellVoltageBeginIndex <= 0">{{ $t('lang.Previous page') }}</el-button>
        <el-button size="mini" type="primary w-100 ml-10" @click="onCellVoltageNextPageClick"
          :disabled="!cellVoltageHasNext">{{ $t('lang.Next page') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Utils from "../../utils/utils";

export default {
  name: "batteryMgmtDetailView",
  props: {
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      batteryNo: "",
      belongTargetInfo: '',
      belongTargetTypeMap: {
        0: this.$t('lang.Name of'),
        1: this.$t('lang.user')
      },
      versionMap: {
        1: "v1.0",
        2: "v2.0"
      },
      useStatusMap: {
        "-1": "超时",
        "0": "待机",
        "1": "搁置",
        "2": "放电",
        "3": "充电"
      },
      status: 0,
      editStatus: "",
      statusMap: {
        0: "待出厂",
        1: "待投放（已出厂）",
        2: "已投放",
        3: "待投放（返厂）",
        4: "报废"
      },
      statusList: [
        {
          name: "待投放（返厂）",
          id: 3
        },
        {
          name: "报废",
          id: 4
        }
      ],
      data: {},
      cellVoltageDialogVisible: false,
      cellSeqNoList: [],
      cellSeqNo: "",
      cellVoltageStartTime: "",
      cellVoltageEndTime: "",
      cellVoltageBeginIndex: 0,
      cellVoltagePageSize: 5,
      tableData: [],
      loading: false,
      cellVoltageHasNext: true,
      queryResultInterval: null,
      domainType: ''
    };
  },
  watch: {
    editData: {
      handler() {
        this.batteryNo = this.editData.deviceNo;
        this.belongTargetInfo = this.editData.belongTargetInfo;
        this.queryChargeDetail();
      },
      deep: true
    }
  },
  mounted() {
    this.cellVoltageStartTime = Utils.getCurrentDate() + " 00:00";
    this.cellVoltageEndTime = Utils.getCurrentDate() + " 23:59";
    let domain = Utils.getDomain();
    if (domain == 'iot.lititi.com' || domain == 'hailixinnengyuan.com' || domain == 'leasehold-test.lititi.com' || domain == 'leasehold-dev.lititi.com') {
      this.domainType = '2';
    }
    this.queryResultInterval = setInterval(this.queryChargeDetail, 2000)
  },
  destroyed() {
    this.clearQueryResultInterval();
  },
  methods: {
    clearQueryResultInterval: function () {
      this.queryResultInterval && clearInterval(this.queryResultInterval);
      this.queryResultInterval = null;
    },
    queryChargeDetail() {
      let self = this;
      let params = {
        batteryNo: this.batteryNo
      };
      this.$http
        .post(
          "/managementPlatform/electricity/queryBatteryDetail",
          this.$qs.stringify(params)
        )
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message || "查询失败!",
              center: true
            });
            return;
          }
          self.status = res.mdata.batteryDetail.status;
          self.editStatus = self.statusMap[self.status];
          self.data = res.mdata.batteryDetail;
        })
        .catch(function (response) {
          console.log(response);
        });
    },
    onSingingStatusBtnClick() {
      let self = this;
      let status = this.data.singingStatus;
      let msg = "";
      let operate = "";
      if (status == 1) {
        msg = "是否确认停止蜂鸣？";
        operate = "18";
      } else {
        msg = "是否确认蜂鸣？";
        operate = "18";
      }
      this.$confirm(msg, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          self.operateBattery(operate);
          setTimeout(function () {
            self.queryChargeDetail();
          }, 1000)

        })
        .catch(action => {
        });
    },
    onChangeLockStatusBtnClick() {
      let self = this;
      let status = this.data.dischargeMosStatus;
      let msg = "";
      let operate = "";
      if (status == 1) {
        msg = "是否确认锁定？";
        operate = "10";
      } else {
        msg = "是否确认解锁？";
        operate = "11";
      }
      this.$confirm(msg, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          self.operateBattery(operate);
        })
        .catch(action => {
        });
    },
    onChangeMosStatusBtnClick() {
      let self = this;
      let status = this.data.chargeMosStatus;
      let msg = "";
      let operate = "";
      if (status == 1) {
        msg = "是否确认关闭充电？";
        operate = "22";
      } else {
        msg = "是否确认开启充电？";
        operate = "21";
      }
      this.$confirm(msg, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          self.operateBattery(operate);
        })
        .catch(action => {
        });
    },
    onDisChangeMosStatusBtnClick() {
      let self = this;
      let status = this.data.dischargeMosStatus;
      let msg = "";
      let operate = "";
      if (status == 1) {
        msg = "是否确认关闭放电？";
        operate = "24";
      } else {
        msg = "是否确认开启放电？";
        operate = "23";
      }
      this.$confirm(msg, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          self.operateBattery(operate);
        })
        .catch(action => {
        });
    },
    operateBattery(operate) {
      let self = this;
      let params = {
        batteryNo: this.batteryNo,
        operate: operate
      };
      this.$http
        .post(
          "/managementPlatform/electricity/operateBattery",
          this.$qs.stringify(params)
        )
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message,
              center: true
            });
            return;
          }
          self.$message({
            type: "success",
            message: "操作成功!",
            center: true
          });
        })
        .catch(function (response) {
          console.log(response);
        });
    },
    cancel() {
      this.editStatus = this.status;
      this.dialogVisible = false;
    },
    confirm() {
      this.changeBatteryStatus();
    },
    changeBatteryStatus() {
      let self = this;
      let params = {
        param: this.batteryNo,
        status: this.editStatus
      };
      this.$http
        .post(
          "/managementPlatform/electricity/editBatteryUseStatus",
          this.$qs.stringify(params)
        )
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message,
              center: true
            });
            return;
          }
          self.$message({
            type: "success",
            message: "切换成功!",
            center: true
          });
          self.status = self.editStatus;
          self.dialogVisible = false;
        })
        .catch(function (response) {
          console.log(response);
        });
    },
    queryCellSeqNoList(batteryNo) {
      let self = this;
      let params = {
        batteryNo: batteryNo
      };
      this.$http
        .post(
          "/managementPlatform/electricity/queryBatteryCellSeqNoList",
          this.$qs.stringify(params)
        )
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message,
              center: true
            });
            return;
          }
          self.cellSeqNoList = res.ldata;
        })
        .catch(function (response) {
          console.log(response);
        });
    },

    onCellVoltageBtnClick() {
      this.cellVoltageBeginIndex = 0;
      this.cellVoltageHasNext = true;
      this.queryCellSeqNoList();
      this.queryBatteryCellSnapshot();
      this.cellVoltageDialogVisible = true;
    },
    onCellVoltageQueryClick() {
      this.cellVoltageBeginIndex = 0;
      this.cellVoltageHasNext = true;
      this.queryBatteryCellSnapshot();
    },
    onCellVoltagePrePageClick() {
      if (this.cellVoltageBeginIndex > 0) {
        this.cellVoltageBeginIndex -= this.cellVoltagePageSize;
        this.queryBatteryCellSnapshot();
      }
    },
    onCellVoltageNextPageClick() {
      if (this.cellVoltageHasNext) {
        this.cellVoltageBeginIndex += this.cellVoltagePageSize;
        this.queryBatteryCellSnapshot();
      }
    },
    queryCellSeqNoList() {
      let self = this;
      let params = {
        batteryNo: self.batteryNo
      };
      this.$http
        .post(
          "/managementPlatform/electricity/queryBatteryCellSeqNoList",
          this.$qs.stringify(params)
        )
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message,
              center: true
            });
            return;
          }
          self.cellSeqNoList = res.ldata;
        })
        .catch(function (response) {
          console.log(response);
        });
    },
    queryBatteryCellSnapshot() {
      this.loading = true;
      let self = this;
      let params = {
        batteryNo: self.batteryNo,
        cellSeqNo: self.cellSeqNo,
        startTime: self.cellVoltageStartTime,
        endTime: self.cellVoltageEndTime,
        beginIndex: self.cellVoltageBeginIndex,
        pageSize: self.cellVoltagePageSize
      };
      this.$http
        .post(
          "/managementPlatform/electricity/queryBatteryCellSnapshot",
          this.$qs.stringify(params)
        )
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message,
              center: true
            });
            return;
          }
          self.tableData = res.ldata;
          if (self.tableData.length < self.cellVoltagePageSize) {
            self.cellVoltageHasNext = false;
          } else {
            self.cellVoltageHasNext = true;
          }
          self.tableData.forEach(item => {
            item.electricVoltage += "V";
            item.cellSeqNo += "号";
          });
          self.loading = false;
        })
        .catch(function (response) {
          self.loading = false;
          console.log(response);
        });
    }
  },
};
</script>
<style lang="scss" scoped>
.list {
  line-height: 30px;
  margin: 20px 30px 10px;
  overflow: hidden;

  .name-label {
    float: left;
  }

  .value-label {
    float: left;
    width: 17%;
    height: 30px;
  }

  .date-global {
    width: 185px;
  }

  .list-input {
    width: 180px;
  }
}

.table-custom {
  .text-btn {
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #bee6b3;
    cursor: pointer;
    padding: 2px 8px;
  }

  .fixed-width-75 {
    width: 75px;
  }

  .fixed-width-120 {
    width: 120px;
  }

  .fixed-width-60 {
    width: 60px;
  }
}

.ml-40 {
  margin-left: 40px;
}

.ml-10 {
  margin-left: 10px;
}

.w-100 {
  width: 100px;
}

.mt4 {
  margin-top: 4px;
}

.mt-10 {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/batteryMgmtDetailView.vue